import { lazy, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotFound from '../modules/errors/ErrorsPage';
import ProtectedRoute from './ProtectedRoute';
import SwitchAccount from '../modules/auth/components/SwitchAccount';
import AuthenticatedRoute from './AuthenticatedRoute';
import PublicRoute from './PublicRoute';
import { PORTAL_TYPES } from '../constants/roles';
import OrderEmail from '../components/common/detail/OrderEmail';
const AuthRoutes = lazy(() => import('../modules/auth/AuthPage'));
const SystemPortalRoutes = lazy(() => import('./SystemPortalRoutes'));
const TenantPortalRoutes = lazy(() => import('./TenantPortalRoutes'));
const BranchPortalRoutes = lazy(() => import('./BranchPortalRoutes'));

const AppRoutes = () => {
	const location = useLocation();
	useEffect(() => {}, [location]);
	const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
	const currentRole = useSelector((state: any) => {
		return state.auth.currentRole;
	});
	const isSystemPortalRole = currentRole?.portal_type === PORTAL_TYPES.SYSTEM_PORTAL;
	const isTenantPortalRole = currentRole?.portal_type === PORTAL_TYPES.TENANT_PORTAL;
	const isBranchPortalRole = currentRole?.portal_type === PORTAL_TYPES.BRANCH_PORTAL;

	return (
		<Routes>
			{isSystemPortalRole && (
				<Route element={<AuthenticatedRoute hasAccess={isLoggedIn} />}>
					<Route path='/*' element={<SystemPortalRoutes />} />
				</Route>
			)}
			{isTenantPortalRole && (
				<Route element={<AuthenticatedRoute hasAccess={isLoggedIn} />}>
					<Route path='/*' element={<TenantPortalRoutes />} />
				</Route>
			)}
			{isBranchPortalRole && (
				<Route element={<AuthenticatedRoute hasAccess={isLoggedIn} />}>
					<Route path='/*' element={<BranchPortalRoutes />} />
				</Route>
			)}
			{!isSystemPortalRole &&
				!isTenantPortalRole &&
				!isBranchPortalRole &&
				!isLoggedIn && <Route path='*' element={<Navigate to='/auth' />} />}
			{/* {!isLoggedIn &&  */}
			<Route path='/order-link/:id' element={<OrderEmail />} />
			{/* } */}
			<Route element={<PublicRoute isLoggedIn={isLoggedIn} />}>
				<Route path='/auth/*' element={<AuthRoutes />} />
			</Route>
			<Route
				path='/switch-account'
				element={
					<ProtectedRoute path='switch-account'>
						<SwitchAccount />
					</ProtectedRoute>
				}
			/>
			<Route path='/404/*' element={<NotFound />} />
			<Route path='*' element={<Navigate to='/404' />} />
		</Routes>
	);
};

export default AppRoutes;
